export default __webpack_public_path__ + "static/per-marker-customisation-fb022a997fc573440f8d4e92280f5348.png";